var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58115 1.77853C6.18288 1.77853 5.84768 1.77853 5.47754 1.77853C5.47754 1.17902 5.47754 0.617705 5.47754 0.0125732C7.2519 0.0125732 9.03331 0.0125732 10.8518 0.0125732C10.8518 0.569477 10.8518 1.12879 10.8518 1.77853C9.45281 1.77853 8.04851 1.77853 6.58115 1.77853Z",
    fill: "#184D98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6183 3.40061C17.1178 3.72984 17.1049 4.04749 16.707 4.41148C16.4495 4.64704 16.2323 4.92651 15.9523 5.23565C15.0794 4.49875 14.2189 3.7723 13.2949 2.99222C13.6316 2.59474 13.9269 2.20621 14.2715 1.86783C14.3555 1.7854 14.6537 1.8 14.7638 1.88546C15.382 2.36536 15.9727 2.88058 16.6183 3.40061Z",
    fill: "#184D98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5821 7.49339C14.4091 5.01481 12.4778 3.43337 9.76472 2.86159L9.76471 2.86159C9.56926 2.84249 9.37382 2.82339 9.09583 2.76425C8.43262 2.72102 7.85195 2.71781 7.27127 2.7146C7.06691 2.77314 6.86255 2.83168 6.56186 2.88678C6.52698 2.89611 6.4924 2.90535 6.4581 2.91452C5.91651 3.05922 5.44605 3.18492 4.99949 3.36869C0.906761 5.05291 -1.01331 9.66654 0.532283 13.7123C2.05532 17.699 6.51329 20.0156 10.7329 18.5394C13.5251 17.5625 15.2626 15.621 16.0654 12.8427C16.5903 11.026 16.3895 9.19939 15.5821 7.49339ZM9.04554 5.46059V5.46016H7.27599V11.7582H7.2763V11.7587H8.10573H9.04585V5.46059H9.04554Z",
    fill: "#184D98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIcon);
export default __webpack_public_path__ + "static/media/timerIcon.9d45daed1a5c4b4e391e55146e907df5.svg";
export { ForwardRef as ReactComponent };